import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function getToken() {
  return localStorage.getItem("tardigrade_token") || "";
}
export function setToken(t) {
  if (t) localStorage.setItem("tardigrade_token", t);
}
export function clearToken() {
  localStorage.removeItem("tardigrade_token");
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const cfg = error.config || {};
    // 401 = invalid/expired token. 403 on a normal (non-opt-out) call usually
    // means the stored token is for a different role (multi-tab login clobber).
    if ((status === 401 || status === 403) && !cfg.skipAuthRedirect) {
      const onLogin = window.location.pathname.startsWith("/login");
      if (!onLogin) {
        clearToken();
        toast.error("Your session changed. Please log in again.");
        setTimeout(() => { window.location.href = "/login"; }, 600);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
